import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';

function calculateTotalProdutos(produtos, precision) {
  return currency(produtos.map(a => a.produto.total)
    .reduce((a, b) => currency(a, { DEFAULT_PRECISION })
      .add(currency(b, { DEFAULT_PRECISION }))), { precision }).value;
}

function calculateTotalConvertidoProdutos(produtos, precision) {
  return currency(produtos.map(a => a.produto.valorMoedaConvertido.total)
    .reduce((a, b) => currency(a, { DEFAULT_PRECISION })
      .add(currency(b, { DEFAULT_PRECISION }))), { precision }).value;
}

export function totalProdutos(produtos, precisionProdutos) {
  return {
    total: calculateTotalProdutos(produtos, precisionProdutos),
    totalConvertido: calculateTotalConvertidoProdutos(produtos, precisionProdutos),
  };
}

export default {
  totalProdutos,
};
